import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ErrorModelData } from '../../../vass-core/interfaces/error-model-data.interface';

import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: false,
})
export class ErrorComponent implements OnInit {
  @Input() isComponent: boolean;

  public error: ErrorModelData;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.getErrorParams();
  }

  private getErrorParams() {
    this.activatedRoute.queryParams
      .pipe(filter((errorParams) => !!errorParams.error))
      .subscribe((errorParams) => {
        this.error = JSON.parse(errorParams.error);
      });
  }
}
